export default "__VITE_ASSET__B5MfAyVK__"